/**
* 公司自定义全局参数
*/
const companyGlobalParam = {
  
addCompanyGlobalParam: "/api/addCompanyGlobalParam",//增加公司全局参数
modifyCompanyGlobalParam: "/api/modifyCompanyGlobalParam",//修改公司全局参数
deleteCompanyGlobalParam: "/api/deleteCompanyGlobalParam",//删除公司全局参数
getCompanyGlobalParams: "/api/getCompanyGlobalParams",//查询公司全局参数
}

export default companyGlobalParam